export default __webpack_public_path__ + "static/media/s9.d44dc0df.jpg";